import React from 'react'
import {BatchCardHeader} from './BatchCardHeader'

type Props = {
  title: string
  subtitle: string
  errorMessage?: string
  columns: {title: string; className: string; value: string | JSX.Element}[]
  icon?: boolean
}

export function BatchCard({title, subtitle, errorMessage, columns, icon = false}: Props) {
  return (
    <>
      <div className='card mb-6 mb-xl-8'>
        <div className='card-body ps-12 pt-8'>
          <BatchCardHeader title={title} subtitle={subtitle} icon={icon} />
          {errorMessage && <div className='fw-semibold text-danger px-3 pb-3'>{errorMessage}</div>}
          <div className='overflow-auto'>
            <>
              <div className='d-flex align-items-center min-w-750px px-7 py-3'>
                {columns.map((column, index) => (
                  <span
                    key={index}
                    className={`fs-2 text-gray fw-semibold w-375px me-4 ${column.className}`}
                  >
                    {column.title}
                  </span>
                ))}
              </div>

              <div className='d-flex align-items-center border border-dashed border-gray-300 rounded min-w-750px px-7 py-3'>
                {columns.map((column, index) => (
                  <div key={index} className={`fs-2 fw-semibold w-375px me-4 ${column.className}`}>
                    {column.value}
                  </div>
                ))}
              </div>
            </>
          </div>
        </div>
      </div>
    </>
  )
}
